module.exports = __webpack_public_path__ + "static/img/usa-flag.5d8ec8f0.svg";